//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      inquiry: {},
      orderId: ""
    };
  },
  created() {
    document.title='随访单详情';
    if(!this.$store.state.userInfo.sessionId){
      this.$store.state.userInfo.sessionId = 'haozhongyi';
    }
    this.orderId = this.$route.query.orderId;
    this.query();
  },
  methods: {
    query() {
      var _this = this;
      var data = {
        prescriptionOrderId: this.orderId,
        isFollowsingle: 1,
        ischecked: 1
      };
      this.$doRequest("/api/Inquiry/orderDetails", data, res => {
        _this.inquiry = res;
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/upload/fivex/fivex.vue